import React from 'react';
import { FaCheckCircle, FaTrash } from 'react-icons/fa';

const CusNotiCard = ({ notification, onMarkRead, onDelete }) => {
  const formatTimeAgo = (date) => {
    const now = new Date();
    const diff = now - new Date(date);
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(diff / 3600000);
    const days = Math.floor(diff / 86400000);

    if (minutes < 1) return 'Just now';
    if (minutes < 60) return `${minutes}m ago`;
    if (hours < 24) return `${hours}h ago`;
    if (days === 1) return 'Yesterday';
    if (days < 7) return `${days}d ago`;

    return new Date(date).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: new Date(date).getFullYear() !== now.getFullYear() ? 'numeric' : undefined,
    });
  };

  return (
    <div className={`cus-noti-card ${notification.status === 'unread' ? 'unread' : ''}`}>
      {/* Icon */}
      <div
        className="cus-noti-card-icon"
        style={{ backgroundColor: `${notification.color}18` }}
      >
        <span style={{ fontSize: '22px' }}>{notification.icon}</span>
      </div>

      {/* Content */}
      <div className="cus-noti-card-content">
        <div className="cus-noti-card-top">
          <h3 className="cus-noti-card-title">
            {notification.notification_title}
            {notification.status === 'unread' && (
              <span className="cus-noti-unread-dot">●</span>
            )}
          </h3>
          <span className="cus-noti-card-time">
            {formatTimeAgo(notification.created_at)}
          </span>
        </div>

        <p className="cus-noti-card-msg">{notification.notification_description}</p>

        {notification.relatedEntityName && (
          <span
            className="cus-noti-card-entity"
            style={{
              backgroundColor: `${notification.color}12`,
              color: notification.color,
            }}
          >
            {notification.relatedEntityName}
          </span>
        )}
      </div>

      {/* Actions */}
      <div className="cus-noti-card-actions">
        {notification.status === 'unread' && (
          <button
            className="cus-noti-action-btn read"
            onClick={() => onMarkRead && onMarkRead(notification.id)}
            title="Mark as read"
          >
            <FaCheckCircle />
          </button>
        )}
        <button
          className="cus-noti-action-btn del"
          onClick={() => onDelete && onDelete(notification.id)}
          title="Delete"
        >
          <FaTrash />
        </button>
      </div>
    </div>
  );
};

export default CusNotiCard;